export default {
  seaRoutes: null,
  seaRouteDetailCondition: {}
}